<nz-card>
	<app-splitbutton *ngIf="hasProjectCreatePermission"
			[elements]="[projectAddSplitButton]" class="tablebutton"
	></app-splitbutton>
	<nz-table #dynamicTable [nzData]="listOfDisplayData" [nzBordered]="bordered"
				[nzSimple]="simple" [nzLoading]="loading" [nzPaginationPosition]="position" [nzShowSizeChanger]="sizeChanger"
				[nzFrontPagination]="pagination" [nzShowPagination]="pagination" [nzFooter]="footer ? 'Here is the Footer' : null"
				[nzTitle]="title ? 'Here is the Title' : null" [nzSize]="size" (nzCurrentPageDataChange)="currentPageDataChange($event)"
				class="kit__utils__table" [hidden]="privacyMode"
				style="overflow-x: hidden"
	>
		<thead>
		<tr *ngIf="header">
			<th nzCustomFilter
				[nzSortFn]="compareName"
			>
				{{ 'projects.name' | translate}}
				<nz-filter-trigger [(nzVisible)]="nameFilterVisible" [nzActive]="nameFilterValue.length > 0" [nzDropdownMenu]="menuName">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuName="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="nameFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'projects.name' | translate } }}" (ngModelChange)="filterName()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>

			<th nzCustomFilter
				[nzSortFn]="comparePid"
			>
				{{ 'projects.id' | translate}}
				<nz-filter-trigger [(nzVisible)]="pidFilterVisible" [nzActive]="pidFilterValue.length > 0" [nzDropdownMenu]="menuPid">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuPid="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="pidFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'projects.id' | translate } }}" (ngModelChange)="filterPid()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>

			<th nzCustomFilter
				[nzSortFn]="compareServer"
			>
				{{ 'projects.server_id' | translate}}
				<nz-filter-trigger [(nzVisible)]="serverFilterVisible" [nzActive]="serverFilterValue.length > 0" [nzDropdownMenu]="menuServer">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuServer="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="serverFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'projects.server_id' | translate } }}" (ngModelChange)="filterServer()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>

			<th nzCustomFilter
				[nzSortFn]="compareDescription"
			>
				{{ 'word.description' | translate}}
				<nz-filter-trigger [(nzVisible)]="descriptionFilterVisible" [nzActive]="descriptionFilterValue.length > 0"
									[nzDropdownMenu]="menuDescription">
					<i nz-icon nzType="filter"></i>
				</nz-filter-trigger>

				<nz-dropdown-menu #menuDescription="nzDropdownMenu">
					<div class="ant-table-filter-dropdown">
						<div class="search-box">
							<input type="text" nz-input [(ngModel)]="descriptionFilterValue" placeholder="{{ 'actions.searchFor' | translate :
							{searchItem : 'word.description' | translate } }}" (ngModelChange)="filterDescription()"/>
						</div>
					</div>
				</nz-dropdown-menu>
			</th>
		</tr>
		</thead>
		<tbody>
		<ng-template ngFor let-data [ngForOf]="dynamicTable.data">
			<tr (click)="showProjectEdit(data)" [ngClass]="{'selectedProject': data.project_id === activeProject?.project_id}">
				<td>{{ data.projectname }}</td>
				<td>{{ data.project_id }}</td>
				<td>{{ data.server_id }}</td>
				<td>{{ data.description }}</td>
			</tr>
		</ng-template>
		</tbody>
	</nz-table>
</nz-card>

<nz-modal
		[nzMaskClosable]="false"
		nzTitle="{{ 'projects.change_title' | translate }}" (nzOnOk)="changeProject(selectedProject)"
		(nzOnCancel)="handleCancel()"
		[nzVisible]="modalVisible"
		nzOkText="{{ 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
>
	{{ 'projects.change_text' | translate }}
</nz-modal>
